<template lang="pug">
include applicant-guardian-consent.pug
</template>

<script>
import NavigationButtons from '@/components/shared/navigationButtons'
import EmailInput from '@/components/shared/emailInput'
import TermsCheckbox from '@/components/shared/termsCheckbox'
import { createNamespacedHelpers } from 'vuex'
import services from '@/services'
const { mapState: mapGlobalState } = createNamespacedHelpers('globals')

import { getterTypes, mutationTypes } from '@/store/application'
const applictionStore = createNamespacedHelpers('application')

export default {
  name: 'ApplicantGuardianConsent',
  components: {
    navigationButtons: NavigationButtons,
    emailInput: EmailInput,
    termsCheckbox: TermsCheckbox
  },
  data: function () {
    return {
      emails: {}
    }
  },
  computed: {
    ...mapGlobalState({
      texts: (state) => state.texts.applicantGuardianConsent
    }),
    ...applictionStore.mapGetters({
      completed: getterTypes.APPLICANT_GUARDIAN_CONSENT_COMPLETED
    }),
    ...applictionStore.mapState({
      termsAccepted: (state) => state.applicantGuardianConsentTermsAccepted,
      guardians: (state) => state.guardians
    }),
    previousStepAvailable: function () {
      return services.application.previousStepAvailable()
    }
  },
  beforeMount: function () {
    for (const guardian of this.guardians) {
      this.emails[guardian.id] = guardian.email
    }
  },
  methods: {
    ...applictionStore.mapMutations({
      setGuardianEmail: mutationTypes.SET_APPLICANT_GUARDIAN_EMAIL,
      setTermsAccepted: mutationTypes.SET_APPLICANT_GUARDIAN_CONSENT_TERMS_ACCEPTED
    }),
    emailcallback: function (id, email) {
      this.emails[id] = email.value
      this.setGuardianEmail({ id: id, email: email.validationAccepted ? email.value : undefined })
    },
    onPreviousStepClicked: function () {
      services.application.previousStep()
    },
    onNextStepClicked: function () {
      services.application.nextStep()
    }
  }
}
</script>
